var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#31978C"
    },
    d: "M96,56h288c17.7,0,32,14.3,32,32v336c0,17.7-14.3,32-32,32H96c-17.7,0-32-14.3-32-32V88 C64,70.3,78.3,56,96,56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#44C4A1"
    },
    d: "M112,72h272c8.8,0,16,7.2,16,16v320c0,8.8-7.2,16-16,16H112c-8.8,0-16-7.2-16-16V88 C96,80.2,103.2,72,112,72z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 56,
    style: {
      fill: "#3EA69B"
    },
    width: 48,
    height: 400,
    rx: 8
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#31978C"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 136,
    width: 192,
    height: 12,
    rx: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 176,
    width: 192,
    height: 12,
    rx: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 216,
    width: 144,
    height: 12,
    rx: 6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 256,
    width: 176,
    height: 12,
    rx: 6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 296,
    width: 128,
    height: 12,
    rx: 6
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F6C358"
    },
    points: "200,56 200,120 216,104 232,120 232,56"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 280) rotate(-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -100,
    style: {
      fill: "#FCD462"
    },
    width: 24,
    height: 120,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -60,
    style: {
      fill: "#DC8744"
    },
    width: 24,
    height: 16
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3EA69B"
    },
    points: "-12,20 12,20 0,44"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#31978C"
    },
    points: "-4,34 4,34 0,44"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -108,
    style: {
      fill: "#DC8744"
    },
    width: 24,
    height: 16,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240, 340)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F6C358"
    },
    cx: 0,
    cy: 0,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCD462"
    },
    cx: 0,
    cy: 0,
    r: 26
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC8744"
    },
    d: "M-2,-18v4c-5.5,0.5-9.5,2.5-12,5.5c-1.5,2-2,4-2,6.5c0,3,1.2,5.2,3.5,7c2.5,1.8,6,3,10.5,3.5v10 c-3.5-0.5-6.5-1.8-9-4l-3,4.5c3.5,3,7.5,4.5,12,5v4h4v-4c5.5-0.5,9.8-2.5,12.5-5.5c1.5-2,2.2-4.2,2.2-6.5 c0-3-1.2-5.5-3.5-7.2c-2.5-1.8-6.2-3-11.2-3.5v-10c3,0.5,5.5,1.5,8,3.5l3-4.5c-3-2.5-6.8-4-11-4.5v-4H-2z M-2,-8v9 c-3-0.5-5-1.2-6.2-2.2c-1.2-1-1.8-2.2-1.8-3.5C-10,-7,-7.5,-8.5,-2,-8z M2,10v9c3.2-0.5,5.2-1.2,6.5-2.2 c1.2-1,1.8-2.2,1.8-3.5C10.2,11,7.5,9.5,2,10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBook);
export default __webpack_public_path__ + "static/media/service-book.31c50cf1ea66c09f5cfd43ec74a96ada.svg";
export { ForwardRef as ReactComponent };